module.exports = require("./lib/_stream_transform.js")



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-scripts/~/stream-browserify/~/readable-stream/transform.js
 ** module id = 395
 ** module chunks = 0
 **/